export default "__VITE_ASSET__cf2174e3__"